import type { YearlyMileageOptionDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/opc';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { getCarYearlyMileagesWithSuggestionSelector } from '../recoil/selectors/getCarYearlyMileagesWithSuggestionSelector';
import type { MVPYearlyMileage_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';
import { OnlineSales } from 'gw-edge-client';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import { opcInfoAtom } from '../recoil/atoms/opcInfoAtom';
import { isAxiosError } from 'axios';
import { useAsyncThrow } from './useAsyncThrow';

export const useYearlyMileagesAndOdometerReading = (): {
    options: YearlyMileageOptionDTO[];
    suggestedMileage: MVPYearlyMileage_Top;
    setSuggestedMileage: React.Dispatch<React.SetStateAction<MVPYearlyMileage_Top>>;
    canSaveOdometerAndMileage: (
        odometerValue: string,
        yearlyMileage: MVPYearlyMileage_Top
    ) => Promise<string>;
} => {
    const { options, suggestedValue } = useRecoilValue(getCarYearlyMileagesWithSuggestionSelector);
    const [suggestedMileage, setSuggestedMileage] = useState<MVPYearlyMileage_Top>(suggestedValue);
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const { asyncThrow } = useAsyncThrow();
    const { coverableId } = useRecoilValue(opcInfoAtom);

    const canSaveOdometerAndMileage = async (
        odometerValue: string,
        yearlyMileage: MVPYearlyMileage_Top
    ): Promise<string> => {
        try {
            await OnlineSales.validateCarOdometerReading(
                jobNumber,
                sessionId,
                coverableId,
                odometerValue,
                yearlyMileage
            );
        } catch (error) {
            if (isAxiosError(error)) {
                return error.response?.data.error.pureMessage_Top as string;
            }
            asyncThrow(error as Error);
        }
        return '';
    };

    return {
        options,
        suggestedMileage,
        setSuggestedMileage,
        canSaveOdometerAndMileage
    };
};
